import HttpClient from '@/utility/http-client';
export default {
    submitWithdrawal(dataRequest: any) {
        const url = `/api/withdraw/`;
        return HttpClient.instance().put(url, dataRequest);
    },

    paymentHistories(page: number, rowPerPage: number, q: any) {
        const url = `/api/payment_histories/?page=${page}&rowsPerPage=${rowPerPage}&q=${q}`;
        return HttpClient.instance().get(url);
    },

    walletHistories(page: number, rowPerPage: number) {
        const url = `/api/historypaywallet/?page=${page}&rowsPerPage=${rowPerPage}`;
        return HttpClient.instance().get(url);
    },

    rechargeHistories(page: number, rowPerPage: number, q: any) {
        const url = `/api/recharge_histories/?page=${page}&rowsPerPage=${rowPerPage}&q=${q}`;
        return HttpClient.instance().get(url);
    },

    withdrawalHistories(page: number, rowPerPage: number, q: any) {
        const url = `/api/withdraw/?page=${page}&rowsPerPage=${rowPerPage}&q=${q}`;
        return HttpClient.instance().get(url);
    },

    cumulationHistories(page: number, rowPerPage: number, q: any) {
        const url = `/api/cumulation_history/?page=${page}&rowsPerPage=${rowPerPage}&q=${q}`;
        return HttpClient.instance().get(url);
    },
}